export const services = [
  {
    id: 1,
    icon: "fas fa-network-wired fa-fw",
    title: "IT Infrastructure Setup",
    text: "Crafting robust IT frameworks tailored to your needs.",
  },
  {
    id: 2,
    icon: "fas fa-globe fa-fw",
    title: "Online Business Profile Development",
    text: "Elevate your online presence with our expertise.",
  },
  {
    id: 3,
    icon: "fas fa-laptop-code fa-fw",
    title: "Web Development Services",
    text: "Creating cutting-edge websites and web applications.",
  },
  {
    id: 4,
    icon: "fas fa-toolbox fa-fw",
    title: "Hardware and Software Diagnosis and Repair",
    text: "Swift and reliable troubleshooting.",
  },
  {
    id: 5,
    icon: "fas fa-desktop fa-fw",
    title: "Retail of Computers and IT Accessories",
    text: "Providing quality hardware and accessories.",
  },
  {
    id: 6,
    icon: "fas fa-handshake fa-fw",
    title: "IT Project Outsourcing Assistance",
    text: "Seamlessly manage your projects with our support.",
  },
];
